export const CHAT_MAX_FILES = 4;
export const CHAT_MAX_BYTES_PER_FILE = 3 * 1024 * 1024;
export const CHAT_ACCEPT =
  'image/jpeg,image/png,image/webp,image/gif,application/pdf';

export type ChatAttachmentPayload = {
  mimeType: string;
  base64: string;
  fileName: string;
};

export async function filesToAttachmentPayload(files: File[]): Promise<ChatAttachmentPayload[]> {
  return Promise.all(
    files.map(
      (file) =>
        new Promise<ChatAttachmentPayload>((resolve, reject) => {
          const r = new FileReader();
          r.onload = () => {
            const s = String(r.result);
            const m = /^data:([^;]+);base64,(.+)$/.exec(s);
            if (!m) reject(new Error('No se pudo leer el archivo'));
            else resolve({ mimeType: m[1], base64: m[2], fileName: file.name });
          };
          r.onerror = () => reject(r.error ?? new Error('No se pudo leer el archivo'));
          r.readAsDataURL(file);
        })
    )
  );
}

export function validateChatFile(file: File): string | null {
  if (!CHAT_ACCEPT.split(',').includes(file.type)) {
    return `Tipo no permitido: ${file.name}`;
  }
  if (file.size > CHAT_MAX_BYTES_PER_FILE) {
    return `Cada archivo debe ser de hasta ${CHAT_MAX_BYTES_PER_FILE / (1024 * 1024)} MB`;
  }
  return null;
}

export function validatePendingFiles(files: File[]): string | null {
  if (files.length > CHAT_MAX_FILES) {
    return `Máximo ${CHAT_MAX_FILES} archivos por mensaje`;
  }
  for (const file of files) {
    const error = validateChatFile(file);
    if (error) return error;
  }
  return null;
}

export function chunkChatFiles(files: File[], size = CHAT_MAX_FILES): File[][] {
  const batches: File[][] = [];
  for (let index = 0; index < files.length; index += size) {
    batches.push(files.slice(index, index + size));
  }
  return batches;
}
